import React, { Fragment } from "react";
import { Col, Row } from "react-bootstrap";

import LogoFooter from "../../assets/LogoIPC.svg";
import powered from "../../assets/poweredby.svg";

const Footer = () => {
  return (
    <Fragment>
      <Row>
        <Col lg={3} className="text-center">
          <a href="https://piscinasipc.com/" target="_blank">
            <img src={LogoFooter} alt="Piscinas IPC"></img>
          </a>
        </Col>
        <Col lg={2}>
          <ul>
            <li className="titleLinks">Redes</li>
            <li>
              <a
                href="https://www.instagram.com/piscinasipc/?hl=es-la"
                target="_blank"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/IPCPools.CasaCentral"
                target="_blank"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/user/piscinaspremiumipc"
                target="_blank"
              >
                Youtube
              </a>
            </li>
          </ul>
        </Col>
        <Col lg={3}>
          <ul>
            <li className="titleLinks">Contacto</li>
            <li className="tel">
              <a href="tel:+542614637550">(+54) 261 463 7550</a>
            </li>
            <li>
              <a href="https://g.page/PiscinasIPC?share" target="_blank">
                Casa Central - Fábrica Álvarez Condarco 2060 Parque Industrial
                Las Heras, Mendoza
              </a>
            </li>
          </ul>
        </Col>
        <Col lg={3}>
          <ul>
            <li className="titleLinks">Concesionarios</li>
            <li className="concesionarios">
              <a href="https://piscinasipc.com/contacto/" target="_blank">
                Nuestros puntos de venta
              </a>
            </li>
          </ul>
        </Col>
      </Row>
      <Row className="contentCopyright">
        <Col lg={6} className="copyright">
          <p>
            Copyright © 2021 Piscinas Premium S.A. Todos los Derechos
            Reservados.
          </p>
        </Col>
        <Col lg={6} className="text-end">
          <a href="https://www.possumus.tech/" target="_blank">
            <img src={powered} alt="Powered by Possumus-Koiron"></img>
          </a>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Footer;
